import { render, staticRenderFns } from "./MallItem.vue?vue&type=template&id=2f7f4189&scoped=true"
import script from "./MallItem.vue?vue&type=script&lang=js"
export * from "./MallItem.vue?vue&type=script&lang=js"
import style0 from "./MallItem.vue?vue&type=style&index=0&id=2f7f4189&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f4189",
  null
  
)

export default component.exports